export default __webpack_public_path__ + "static/media/disconnect_menu_icon.31b91086.svg";